import { render } from "./DashboardEmployeesComponent.vue?vue&type=template&id=0c9dd4de&scoped=true"
import script from "./DashboardEmployeesComponent.vue?vue&type=script&lang=js"
export * from "./DashboardEmployeesComponent.vue?vue&type=script&lang=js"

import "./DashboardEmployeesComponent.vue?vue&type=style&index=0&id=0c9dd4de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9dd4de"]])

export default __exports__